import { CLEAR_ERRORS } from './types';

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
